import { AxiosInstance } from "axios";

import { ResponseType } from "@/types/api";
import {
  FAQResponseType,
  GetPostListParamsType,
  PostDetailResponseType,
  PostDetailType,
  PostResponseType,
} from "@/types/post";

class PostAPI {
  private axios;
  private baseUrl;

  constructor(axios: AxiosInstance, baseUrl: string) {
    this.axios = axios;
    this.baseUrl = baseUrl;
  }

  getPostList = async (params?: GetPostListParamsType) => {
    const response = await this.axios.get<ResponseType<PostResponseType[]>>(
      `${this.baseUrl}`,
      { params },
    );
    return response.data;
  };

  getPostDetailBySlug = async (slug: PostDetailType["slug"]) => {
    const response = await this.axios.get<ResponseType<PostDetailResponseType>>(
      `${this.baseUrl}/slug/${slug}`,
    );
    return response.data;
  };

  getFAQList = async () => {
    const response = await this.axios.get<ResponseType<FAQResponseType[]>>(
      `${this.baseUrl}/faq`,
    );
    return response.data;
  };

  addView = async (postId: PostResponseType["id"]) => {
    await this.axios.post(`${this.baseUrl}/view/${postId}`);
  };
}

export default PostAPI;
